export default "__VITE_ASSET__Ix3JBBvM__"